import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { ErrorController } from '@features/error';
import { type FallbackRender } from '@sentry/react';
import * as Sentry from '@sentry/react';

export const sentryErrorFallback: FallbackRender = ({ error: _error, componentStack: _componentStack, resetError }) => {
  return <ErrorController type="unknown" resetError={resetError} />;
};

export const SentryErrorElement = () => {
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return <ErrorController type="unknown" />;
};
